import { FormControl, InputGroup } from 'react-bootstrap';
import { AppShell } from '../../components/AppShell/AppShell';
import { Footer } from '../../components/Footer/Footer';
import { PageHeader } from '../../components/PageHeader/PageHeader';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import styles from './Tootors.module.scss';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Title } from '../../components/Title/Title';
import { useGaming } from '../../../contexts/GamingContext';
import { useCurrentLanguage } from '../../../hooks/useCurrentLanguage';
import { ReactComponent as VideoSearchIcon } from '../../../assets/svg/video-search.svg';
import { useState } from 'react';

const TootorsComponent = () => {
  const { authors } = useFirebase();
  const { track } = useGaming();
  const history = useHistory();
  const { t } = useTranslation();
  const { currentLanguage } = useCurrentLanguage();
  const [search, setSearch] = useState('');

  if (!authors?.length) return <FullscreenLoader />;

  const normalizedSearch = search.trim().toLocaleLowerCase(currentLanguage);
  const filteredAuthors = authors.filter((author) => author.name.toLocaleLowerCase(currentLanguage).includes(normalizedSearch));

  return (
    <AppShell className={styles.shell}>
      <div className={styles.page}>
        <Title>{t('tootors.labels.iNostriToot')}</Title>

          <PageHeader
            title={t('tootors.labels.iNostriToot')}
            subtitle={t('tootors.labels.descrizione')}
          />

          <div className={styles.searchRow}>
            <InputGroup className={styles.tootorSearch}>
              <InputGroup.Prepend>
                <InputGroup.Text className={styles.tootorSearchIcon}>
                  <VideoSearchIcon />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl
                aria-label={t('labels.cerca')}
                className={styles.tootorSearchInput}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Cerca per nome"
                size="lg"
                value={search}
              />
            </InputGroup>
          </div>

          <section className={styles.category}>
            <div className={styles.tootorCardsContainer}>
            {filteredAuthors.map((author) => (
            <button
              type="button"
              className={styles.tootorCard}
              key={author.id}
              onClick={() => {
                track('TOOTOR_CLICK', { authorId: author.id });
                history.push(`/tootors/${author.id}`);
              }}
            >
              <span className={styles.authorsListPhoto}>
                <img src={author.photo || `${process.env.PUBLIC_URL}/logo-oo.png`} alt={author.name} loading="lazy" />
              </span>
              <span className={styles.authorName}>{author.name}</span>
            </button>
          ))}
          </div>
        </section>

        <Footer />
      </div>
    </AppShell>
  );
};

export default TootorsComponent;
